'use client';
export {
  ParallaxBannerLayer,
  ParallaxProvider,
  ParallaxBanner,
} from 'react-scroll-parallax';
